'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageIsApproximatelyFromCurrentSession = undefined;

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

var _ThreadHistoryConstants = require('../../thread-history/constants/ThreadHistoryConstants');

var getMessageIsApproximatelyFromCurrentSession = exports.getMessageIsApproximatelyFromCurrentSession = function getMessageIsApproximatelyFromCurrentSession(message) {
  return Date.now() - (0, _commonMessageFormatGetters.getTimestamp)(message) < _ThreadHistoryConstants.SESSION_EXPIRY_TIME_APPROXIMATION_IN_MS;
};